import { observer } from "mobx-react-lite";
import React from "react";
import { Modal, Form, Radio, Button, Grid } from "semantic-ui-react";
import { howImportant as howImportantEnum } from "../../../../Enums/TitleEnums";
import styles from "./ModalQuestionBox.module.css"

interface HowImportantModalProps {
  handleSelection: (selection: any) => void;
  onClose: () => void;
  howImportant: string;
  nextTaskHandler: () => void;
}

const HowImportantModal: React.FC<HowImportantModalProps> = (props) => {
  const { handleSelection, howImportant, nextTaskHandler, onClose } = props;

  const handleConfirm = () => {
    nextTaskHandler();
  };
  const handleCancel = () => { 
    onClose();
  };

const renderConfirmationContent = () => {
  return (
    <>
    <div className={styles.howImportantConfirmationContents}>
      <Form className={styles.answerForm}>
        <Grid stackable verticalAlign="middle" doubling textAlign="center" padded >
          <Grid.Row>
            <Form.Field className={styles.answerFormField}>
              <Radio
                name="howImportantRadioGroup"
                label={howImportantEnum.VERY_IMPORTANT}
                value={howImportantEnum.VERY_IMPORTANT}
                checked={howImportant === howImportantEnum.VERY_IMPORTANT}
                onChange={(e) => handleSelection(e)}
                className={`${styles.answerFormRadioBtn} ${styles.howImportantRdBtn}`} 
              />
            </Form.Field>
          </Grid.Row>
          <Grid.Row stretched>
            <Form.Field className={styles.answerFormField}>
              <Radio
                name="howImportantRadioGroup"
                label={howImportantEnum.IMPORTANT}
                value={howImportantEnum.IMPORTANT}
                checked={howImportant === howImportantEnum.IMPORTANT}
                onChange={(e) => handleSelection(e)}
                className={`${styles.answerFormRadioBtn} ${styles.howImportantRdBtn}`}                   />
            </Form.Field>
          </Grid.Row>
          <Grid.Row>
            <Form.Field className={styles.answerFormField}>
              <Radio
                name="howImportantRadioGroup"
                label={howImportantEnum.LESS_IMPORTANT}
                value={howImportantEnum.LESS_IMPORTANT}
                checked={howImportant === howImportantEnum.LESS_IMPORTANT}
                onChange={(e) => handleSelection(e)}
                className={`${styles.answerFormRadioBtn} ${styles.howImportantRdBtn}`} 
              />
            </Form.Field>
          </Grid.Row>
          <Grid.Row>
            <Form.Field className={styles.answerFormField}>
              <Radio
                name="howImportantRadioGroup"
                label={howImportantEnum.NOT_IMPORTANT}
                value={howImportantEnum.NOT_IMPORTANT}
                checked={howImportant === howImportantEnum.NOT_IMPORTANT}
                onChange={(e) => handleSelection(e)}
                className={`${styles.answerFormRadioBtn} ${styles.howImportantRdBtn}`} 
              />
            </Form.Field>
          </Grid.Row>
        </Grid>
      </Form>
    </div>
    </>
  );
};

  return (
    <>
    <Modal open={true} onClose={() => handleCancel()} className={styles.confirmationModalBox} >
      <Modal.Header>How Important Is It That You Complete This Task?</Modal.Header>
      <Modal.Content>
        <div>
          <p className={styles.howImportantText}>
            Select an option below to indicate how important this task is for you to complete. How you rate a 
            task's importance will update the Task List - showing your higher priority tasks first.
          </p>
          {renderConfirmationContent()}
        </div>
      </Modal.Content>
      <Modal.Actions >
        <Button.Group className={styles.howImportantBtnGrp}>
          <Button onClick={() => handleCancel()} content="Stay on This Task" />
          <Button.Or style={{minHeight: '3rem'}} />
          <Button positive onClick={() => handleConfirm()} content="Go to Next Task" />
        </Button.Group>
      </Modal.Actions>
    </Modal>
    </>
  );
};

export default observer(HowImportantModal);
